export type LayoutPositionType =
  | 'bottomCenter'
  | 'bottomLeft'
  | 'center'
  | 'bottomRight'
  | 'topLeft'
  | 'topRight';

export function isLayoutPositionType(
  value: string
): value is LayoutPositionType {
  return [
    'bottomCenter',
    'bottomLeft',
    'center',
    'bottomRight',
    'topLeft',
    'topRight'
  ].includes(value);
}

export const ArrowDirection = {
  Prev: 'prev',
  Next: 'next'
} as const;

export type ArrowDirectionType =
  (typeof ArrowDirection)[keyof typeof ArrowDirection];
